import { render, staticRenderFns } from "./ExpandMenu.vue?vue&type=template&id=8cf918ee&scoped=true&lang=pug"
import script from "./ExpandMenu.vue?vue&type=script&lang=js"
export * from "./ExpandMenu.vue?vue&type=script&lang=js"
import style0 from "./ExpandMenu.vue?vue&type=style&index=0&id=8cf918ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf918ee",
  null
  
)

export default component.exports